module.exports = __webpack_public_path__ + "static/media/pause.b4119d9c.svg";